import React, { useState } from 'react';
import { Popover } from '@headlessui/react';
import Logo from './Logo';
import classNames from '../utility/classNames';
import { Toaster } from 'react-hot-toast';
import { useUser } from '../hooks/useUser';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Icon from './Icon';
import TextButton from './buttons/TextButton';
import getSignInLinks from '../utility/getSignInLinks';
import { sign_in as outseta_sign_in } from '../utility/outsetaLinks';
import { IoNotificationsOutline } from 'react-icons/io5';
import { useNotifications } from '../hooks/useNotifications';
import Notifications from './Notifications';
import FeedbackModal from './FeedbackModal';
import { BsQuestionCircle } from 'react-icons/bs';
import { IoChevronDown } from 'react-icons/io5';
import { logEvent } from 'firebase/analytics';
import { analytics } from '../../firebase/clientApp';
import { Outlet } from 'react-router-dom';

// const footerNavigation = {
//   main: [
//     // { name: 'Blog', href: '/blog' },
//     { name: 'Login', href: `https://propertycast.io/login` },
//     { name: 'Contact Us', href: `https://propertycast.io/contact-us` },
//   ],
//   social: [
//     {
//       name: 'Instagram',
//       href: 'https://instagram.com/',
//       icon: (props) => (
//         <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
//           <path
//             fillRule="evenodd"
//             d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"
//             clipRule="evenodd"
//           />
//         </svg>
//       ),
//     },
//     {
//       name: 'Twitter',
//       href: 'https://twitter.com/',
//       icon: (props) => (
//         <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
//           <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
//         </svg>
//       ),
//     },
//   ],
// };

function Layout({ children }) {
  const { user, userDocData, logout } = useUser();
  const navigate = useNavigate();

  // Get user initial for the profile icon
  const getUserInitial = (userDocData) => {
    if (userDocData && !userDocData.loading) {
      const { email, userName } = userDocData;
      if (userName) {
        return userName[0].toUpperCase();
      } else if (email) {
        return email[0].toUpperCase();
      }
      return 'U';
    }
  };

  const userInitial = getUserInitial(userDocData);

  const { pathname } = useLocation();
  const isHomePage = pathname === '/';
  const isPropertyPage =
    pathname.includes('sharing') ||
    (pathname.includes('properties') && pathname.split('/').length > 2);

  const { sign_in } = getSignInLinks();

  const { newNotifications } = useNotifications();
  const [showNotifications, setShowNotifications] = useState(false);
  const [openFeedback, setOpenFeedback] = useState(false);

  const headerNavigation = [
    {
      name: 'Dashboard',
      pathname: '/dashboard',
      handleClick() {
        navigate(this.pathname);
      },
    },
    {
      name: 'Properties',
      pathname: '/properties',
      handleClick() {
        navigate(this.pathname);
      },
    },
    {
      name: 'Criteria',
      pathname: '/settings',
      handleClick() {
        navigate(this.pathname);
      },
    },
    {
      name: 'Feedback',
      pathname: '',
      handleClick() {
        setOpenFeedback(!openFeedback);
      },
    },
  ];

  const profileMenuNavigation = [
    {
      name: 'Profile',
      pathname: `/users/${user?.uid}`,
      handleClick() {
        navigate(this.pathname);
      },
    },
    {
      name: 'Sign Out',
      pathname: '',
      handleClick() {
        logout();
      },
    },
  ];

  const mobileNavigation = headerNavigation.concat(profileMenuNavigation);

  const feedbackNav = headerNavigation.find((item) => item.name === 'Feedback');
  const desktopNavButtonClasses =
    'text-white text-lg p-1 -m-1 hover:decoration-4 hover:underline hover:underline-offset-[19px] focus:decoration-4 focus:underline focus:underline-offset-[19px] transition';

  if (pathname.includes('embedded')) {
    return (
      <>
        <div>
          <Toaster position="top-right" />
        </div>
        {children}
      </>
    );
  }

  const notificationButton = (
    <button
      type="button"
      onClick={() => setShowNotifications((prev) => !prev)}
      className="relative"
    >
      <IoNotificationsOutline className="text-white text-3xl hover:scale-105 hover:text-primary-500 focus:scale-105" />
      {newNotifications > 0 && (
        <span className="absolute -top-1 -right-[4px] text-xs text-white bg-warning rounded-md h-4 w-4 flex items-center justify-center border-primary-800 border-[1px]">
          <span className="text-sm font-bold">{newNotifications}</span>
          <span className="sr-only">You have a new notification</span>
        </span>
      )}
    </button>
  );

  function logHelp() {
    logEvent(analytics, 'help_link_clicked', {
      user_id: user?.uid,
    });
  }

  return (
    <>
      <div>
        <Toaster position="top-right" />
      </div>
      <div
        className={classNames(
          'min-h-screen',
          isHomePage || (!user && pathname.includes('properties'))
            ? 'bg-white'
            : 'bg-primary-50'
        )}
      >
        <FeedbackModal
          showPrompt={openFeedback}
          setShowPrompt={setOpenFeedback}
        />
        <nav
          as="nav"
          className="bg-primary sticky top-0 z-30 font-normal text-lg tracking-wide"
        >
          <nav className=" w-full mx-auto flex justify-center px-6 sm:px-12 lg:px-16">
            <div className="relative max-w-[1300px] w-full h-14 flex items-center justify-between">
              <Popover className="flex items-center w-full">
                {({ open }) => (
                  <>
                    {isHomePage ? (
                      <div />
                    ) : (
                      <>
                        <Link
                          to="/"
                          className="md:hidden flex justify-center justify-self-center items-center w-24 p-1 bg-primary transition focus:outline-none"
                        >
                          <Logo variant="light" size="small" />
                        </Link>
                        {/* Desktop menu */}
                        {user && !user.loading && (
                          <nav
                            className="hidden md:grid grid-cols-3 w-full items-center justify-between"
                            aria-label="Global"
                          >
                            <ul className="space-x-5">
                              {headerNavigation.map(
                                (item) =>
                                  item.pathname && (
                                    <li
                                      key={item.name}
                                      className="inline-block"
                                    >
                                      <TextButton
                                        text={item.name}
                                        handleClick={() => item.handleClick()}
                                        classes={classNames(
                                          desktopNavButtonClasses,
                                          pathname.includes(item.pathname) &&
                                            'decoration-4 underline underline-offset-[19px] opacity-100 decoration-primary-500 font-medium',

                                          !pathname.includes(item.pathname) &&
                                            'opacity-80'
                                        )}
                                      />
                                    </li>
                                  )
                              )}
                            </ul>

                            <Link
                              to="/"
                              className="flex justify-center justify-self-center items-center w-24 p-1 bg-primary transition focus:outline-none"
                            >
                              <Logo variant="light" size="small" />
                            </Link>

                            <div className="flex items-center justify-end text-md font-medium gap-4 -mr-6">
                              <TextButton
                                type="button"
                                text={feedbackNav.name}
                                handleClick={() => feedbackNav.handleClick()}
                                classes={`text-white tracking-wider px-3 py-1 pt-[5px] rounded-md border border-neutral-50 border-opacity-50 transition hover:border-primary-500 focus:border-primary-500 hover:text-primary-500`}
                              />
                              <TextButton
                                type="button"
                                text={
                                  <a
                                    className="flex items-center gap-[6px] text-white hover:text-primary-500 focus:text-primary-500"
                                    href="https://brrrrbot.outseta.com/support/kb"
                                    onClick={logHelp}
                                    target="_blank"
                                  >
                                    <BsQuestionCircle className="text-2xl opacity-75" />{' '}
                                    <span className="tracking-wider">Help</span>
                                  </a>
                                }
                              />
                              <div className="w-[2px] h-4 mx-1 rounded bg-neutral-50 opacity-20">
                                {' '}
                              </div>
                              {notificationButton}
                              {showNotifications && (
                                <div
                                  className="fixed top-0 bottom-0 left-0 right-0"
                                  onClick={() => setShowNotifications(false)}
                                >
                                  <div
                                    className="absolute top-16 right-6 lg:right-16 xl:right-24"
                                    onClick={(e) => e.stopPropagation()}
                                  >
                                    <Notifications type="navbar" />
                                  </div>
                                </div>
                              )}
                              <Popover.Button className="hidden md:inline-flex items-center justify-center gap-1 ml-[2px] mb-[3px] group focus:outline-none">
                                <span className="sr-only">Open menu</span>

                                <div className="w-6 h-6 pt-[1.5px] bg-primary-500 text-white font-normal rounded-full flex items-center justify-center">
                                  {userInitial}
                                </div>
                                <IoChevronDown
                                  className={classNames(
                                    'text-white opacity-100 text-md group-hover:text-primary-500 group-focus:text-primary-500',
                                    open && 'rotate-180'
                                  )}
                                />
                              </Popover.Button>
                              <Popover.Panel
                                as="nav"
                                aria-label="Profile Menu"
                                className="hidden md:block fixed top-10 right-16 xl:right-24 z-50"
                              >
                                <ul
                                  className="origin-top-right absolute z-50  right-0 sm:-right-2 mt-6 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-primary ring-opacity-5 focus:outline-none"
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  {profileMenuNavigation.map((item, i) => (
                                    <li
                                      key={item.name}
                                      className={classNames(
                                        i !== 0 && 'border-t border-neutral-50'
                                      )}
                                    >
                                      <div className="w-full text-center  ml-1 my-3 text-black">
                                        <TextButton
                                          text={item.name}
                                          handleClick={() => item.handleClick()}
                                          classes={classNames(
                                            'w-full block',
                                            item.pathname === pathname &&
                                              'underline underline-offset-4 font-semibold'
                                          )}
                                        />
                                      </div>
                                    </li>
                                  ))}
                                </ul>
                              </Popover.Panel>
                            </div>
                          </nav>
                        )}
                      </>
                    )}
                  </>
                )}
              </Popover>

              <Popover className="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">
                {({ open }) => (
                  <>
                    {user && !user.loading ? (
                      <>
                        {/* Mobile menu */}
                        <Popover.Overlay className="fixed top-16 left-0 right-0 bottom-0 bg-neutral-100 bg-opacity-75 transition-opacity opacity-100" />
                        <Popover.Button className="md:hidden -mx-2 inline-flex items-center justify-center rounded-md p-2 text-white transition hover:text-primary-500 focus:text-primary-500 focus:outline-none">
                          <span className="sr-only">Open menu</span>
                          {open ? (
                            <Icon
                              icon="FiX"
                              classes="block h-6 w-6"
                              aria-hidden="true"
                            />
                          ) : (
                            <Icon
                              icon="FiMenu"
                              classes="block h-6 w-6"
                              aria-hidden="true"
                            />
                          )}
                        </Popover.Button>
                        <div className="md:hidden flex items-center ml-3">
                          {notificationButton}
                        </div>
                        {showNotifications && (
                          <div
                            className="fixed md:hidden top-0 bottom-0 left-0 right-0"
                            onClick={() => setShowNotifications(false)}
                          >
                            <div
                              className="absolute md:hidden top-16 right-2 w-[350px]"
                              onClick={(e) => e.stopPropagation()}
                            >
                              <Notifications type="navbar" />
                            </div>
                          </div>
                        )}

                        <Popover.Panel
                          as="nav"
                          aria-label="Menu"
                          className="md:hidden"
                        >
                          <ul className="origin-top-right absolute z-50  right-0 sm:-right-2 mt-6 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-primary ring-opacity-5 focus:outline-none">
                            {mobileNavigation.map((item) => (
                              <li key={item.name}>
                                <div className="w-full text-center ml-1 my-3 text-black">
                                  <TextButton
                                    text={item.name}
                                    handleClick={() => item.handleClick()}
                                    classes={classNames(
                                      'w-full block',
                                      item.pathname === pathname &&
                                        'underline underline-offset-4 font-semibold'
                                    )}
                                  />
                                </div>
                              </li>
                            ))}
                          </ul>
                        </Popover.Panel>
                      </>
                    ) : (
                      <>
                        {isHomePage && (
                          <Link
                            to="/login"
                            className="inline-flex items-center px-4 py-1.5 whitespace-nowrap rounded-md text-md text-white bg-primary transition hover:bg-gradient-to-r hover:bg-white hover:text-primary focus:outline-none focus:ring-1 focus:ring-offset-2 focus:ring-neutral-400"
                          >
                            Login
                          </Link>
                        )}
                        {!isHomePage && !user && (
                          <>
                            <TextButton
                              type="button"
                              text={feedbackNav.name}
                              handleClick={() => feedbackNav.handleClick()}
                              classes={`text-white tracking-wider px-2 py-1 rounded border border-white text-md transition mr-6 hover:bg-primary-500 focus:scale-105`}
                            />
                            <Link
                              to="/login"
                              className="inline-flex items-center px-4 py-1.5 whitespace-nowrap rounded-md text-md text-white bg-primary transition hover:bg-gradient-to-r hover:bg-white hover:text-primary focus:outline-none focus:ring-1 focus:ring-offset-2 focus:ring-neutral-400"
                            >
                              About
                            </Link>
                            {/* 
                            <a href={outseta_sign_in}>
                              <button type="button">Login</button>
                            </a> */}
                          </>
                        )}
                      </>
                    )}
                  </>
                )}
              </Popover>
            </div>
          </nav>
        </nav>

        <main
          className={classNames(
            'min-h-screen w-full mx-auto',
            !isPropertyPage &&
              'max-w-[1450px] px-4 py-4 sm:py-12 sm:px-6 lg:px-14 lg:py-[40px] lg:pb-20'
          )}
        >
          {children}
          <Outlet />
        </main>

        {/* <footer className="mt-24 bg-primary sm:mt-12">
          <div className="mx-auto max-w-md py-12 px-4 overflow-hidden sm:max-w-3xl sm:px-6 lg:max-w-7xl lg:px-8">
            <nav
              className="-mx-5 -my-2 flex flex-wrap gap-3 justify-center"
              aria-label="Footer"
            >
              {footerNavigation.main.map((item) => (
                <a
                  key={item.name}
                  href={item.href}
                  className="text-md text-white transition hover:underline hover:underline-offset-4 focus:outline-white focus:outline-offset-4"
                >
                  {item.name}
                </a>
              ))}
            </nav>
            <div className="mt-8 flex justify-center space-x-6">
              {footerNavigation.social.map((item) => (
                <a
                  key={item.name}
                  href={item.href}
                  className="text-white transition hover:underline hover:underline-offset-4 focus:outline-white focus:outline-offset-4"
                >
                  <span className="sr-only">{item.name}</span>
                  <item.icon className="h-6 w-6" aria-hidden="true" />
                </a>
              ))}
            </div>
            <p className="mt-8 text-center text-md text-white">
              &copy; {new Date().getFullYear()} PropertyCast. All rights
              reserved.
            </p>
          </div>
        </footer> */}
      </div>
    </>
  );
}

export default Layout;
